import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Es apto para niños melindrosos?',
    a: 'Sí, el sistema permite "esconder" vegetales rallados en las bases y ofrece sabores familiares como tacos y pasta.'
  }, {
    q: '¿Cuesta mucho dinero?',
    a: 'Al contrario, comprar proteína en bloque y usar ingredientes de despensa básica reduce tu gasto semanal considerablemente.'
  }, {
    q: '¿Puedo congelar las bases?',
    a: 'Absolutamente. Puedes hacer doble base un domingo y tener resuelta la cena de dentro de 15 días.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section bg="white" data-id="element-14">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-[#422006]" data-id="element-15">
        Preguntas Frecuentes
      </h2>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-16">
        {faqs.map((faq, idx) => <div key={idx} className="border-2 border-[#FFF8F0] rounded-2xl overflow-hidden bg-white shadow-sm" data-id="element-17">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-18">
              <span className="text-lg font-bold text-[#422006]" data-id="element-19">{faq.q}</span>
              <ChevronDown className={`text-[#EA580C] transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-20" />
            </button>
            <AnimatePresence data-id="element-21">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-22">
                  <div className="px-6 pb-6 text-[#78350F] leading-relaxed" data-id="element-23">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}